import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import { useCallback, useEffect, useState } from 'react'
import { IUserNotificationChannel } from '@/pages/User/user.types.ts'
import userApi from '@/pages/User/user.api.ts'

const useNotificationsChannelsCtrl = () => {
  const { wait: waitDataLoad, loading: dataLoading } = useHttpLoader()
  const { wait: waitSave, loading: saveLoading } = useHttpLoader()

  const [channels, setChannels] = useState<IUserNotificationChannel[]>([])

  const [emailAddress, setEmailAddress] = useState('')
  const [emailEnabled, setEmailEnabled] = useState<boolean>(false)

  const [telegramChartID, setTelegramChartID] = useState('')
  const [telegramEnabled, setTelegramEnabled] = useState<boolean>(false)

  const loadChannels = useCallback(() => {
    return userApi.loadNotificationChannels().then((resp) => {
      if (resp.status === 'error') return

      setChannels(resp.body.channels)
      const emailChannel = resp.body.channels.find((c) => c.channel === 'EMAIL')
      const telegramChannel = resp.body.channels.find((c) => c.channel === 'TELEGRAM')

      if (emailChannel) {
        setEmailAddress(emailChannel.emailAddress)
        setEmailEnabled(emailChannel.enabled)
      }
      if (telegramChannel) {
        setTelegramChartID(telegramChannel.telegramChatId)
        setTelegramEnabled(telegramChannel.enabled)
      }
    })
  }, [])

  useEffect(() => {
    waitDataLoad(loadChannels())
  }, [])

  const telegramChannel = channels.find((c) => c.channel === 'TELEGRAM')
  const emailChannel = channels.find((c) => c.channel === 'EMAIL')

  const handleSave = () => {
    const job = async () => {
      const promises = []
      if (telegramChartID) {
        promises.push(
          userApi.putNotificationChannel({
            channel: 'TELEGRAM',
            telegramChatId: telegramChartID,
            enabled: telegramChannel ? telegramEnabled : true,
          })
        )
      }
      if (emailAddress) {
        promises.push(
          userApi.putNotificationChannel({
            channel: 'EMAIL',
            emailAddress: emailAddress,
            enabled: emailChannel ? emailEnabled : true,
          })
        )
      }

      await Promise.all(promises)
      return loadChannels()
    }

    waitSave(job())
  }

  return {
    data: {
      dataLoading,
      saveLoading,
      channels,

      telegramChartID,
      emailAddress,
      emailEnabled,
      telegramEnabled,

      telegramChannel,
      emailChannel,
    },
    handlers: {
      setTelegramChartID,
      setEmailAddress,
      handleSave,
    },
  }
}

export default useNotificationsChannelsCtrl
